import styles from "./LoadingScreen.module.css";

interface LoadingScreenProps {
    embedded?: boolean;
}

export function LoadingScreen({ embedded = false }: LoadingScreenProps) {
    return (
        <div className={embedded ? styles.embeddedContainer : styles.container}>
            <div className={styles.logoWrapper}>
                {/* Pulse Effect Background */}
                <div className={styles.pulseEffect} />

                <img src={"/kefi-logo.png"} alt="Kefi Logo" className={styles.logo} />
            </div>

            {!embedded && (
                <div className={styles.textContainer}>
                    <div className={styles.dotsContainer} aria-label="Loading">
                        <span className={styles.dot} />
                        <span className={styles.dot} />
                        <span className={styles.dot} />
                    </div>
                </div>
            )}
        </div>
    );
}
